module.exports = __webpack_public_path__ + "static/media/third_1.eb8d1728.jpg";